import { useDeletePromptTemplateMutation } from '@saaga/shared/store/prompt-template-endpoints.store'
import { useCallback, useState } from 'react'

import type { PromptTemplate } from '@/components/chat/prompt-template.interface'

import { deletePromptTemplate } from './prompt-template-crud.helper'

interface UsePromptTemplateDeleteConfirmReturn {
  templateToDelete: PromptTemplate | null
  handleDeleteRequest: (template: PromptTemplate) => void
  handleDeleteConfirm: () => void
  handleDeleteCancel: () => void
}

export const usePromptTemplateDeleteConfirm = (): UsePromptTemplateDeleteConfirmReturn => {
  const [templateToDelete, setTemplateToDelete] = useState<PromptTemplate | null>(null)
  const [deleteFn] = useDeletePromptTemplateMutation()

  const handleDeleteRequest = useCallback((template: PromptTemplate) => {
    setTemplateToDelete(template)
  }, [])

  const handleDeleteConfirm = useCallback(() => {
    if (!templateToDelete) return
    deletePromptTemplate(templateToDelete.id, deleteFn)
    setTemplateToDelete(null)
  }, [templateToDelete, deleteFn])

  const handleDeleteCancel = useCallback(() => {
    setTemplateToDelete(null)
  }, [])

  return { templateToDelete, handleDeleteRequest, handleDeleteConfirm, handleDeleteCancel }
}
